import Parse from 'html-react-parser';

function BMP20192(props) {
    let svgCode =
    `<svg width="1384" height="156" viewBox="0 0 1384 156" fill="none" xmlns="http://www.w3.org/2000/svg">
    <style type="text/css">
    .boxStyle rect {
        ${props.boxStyle}
    }
    .paramBoxStyle {
        ${props.boxStyle}
    }
    ${props.fontFace}
    </style>
        <rect width="1384" height="156" fill="${props.backgroundFill}" stroke="${props.outlineColour}" stroke-width="5"/>
        <circle cx="910" cy="63.4545" r="36" fill="${props.paramFill}"/>
        <rect x="907.818" y="22" width="4.36364" height="4.36364" fill="${props.paramFill}"/>
        <rect x="878.551" y="91.8182" width="4.36364" height="4.36364" transform="rotate(-45 878.551 91.8182)" fill="${props.paramFill}"/>
        <rect x="935.091" y="91.6312" width="4.36364" height="4.36364" transform="rotate(-45 935.091 91.6312)" fill="${props.paramFill}"/>
        <circle cx="1010" cy="63.4545" r="36" fill="${props.paramFill}"/>
        <rect x="1007.82" y="22" width="4.36364" height="4.36364" fill="${props.paramFill}"/>
        <rect x="978.551" y="91.8182" width="4.36364" height="4.36364" transform="rotate(-45 978.551 91.8182)" fill="${props.paramFill}"/>
        <rect x="1035.09" y="91.6312" width="4.36364" height="4.36364" transform="rotate(-45 1035.09 91.6312)" fill="${props.paramFill}"/>
        <circle cx="1110" cy="63.4545" r="36" fill="${props.paramFill}"/>
        <rect x="1107.82" y="22" width="4.36364" height="4.36364" fill="${props.paramFill}"/>
        <rect x="1078.55" y="91.8182" width="4.36364" height="4.36364" transform="rotate(-45 1078.55 91.8182)" fill="${props.paramFill}"/>
        <rect x="1135.09" y="91.6312" width="4.36364" height="4.36364" transform="rotate(-45 1135.09 91.6312)" fill="${props.paramFill}"/>
        <circle cx="470" cy="63.4545" r="36" fill="${props.paramFill}"/>
        <rect x="467.818" y="22" width="4.36364" height="4.36364" fill="${props.paramFill}"/>
        <rect x="438.551" y="91.8182" width="4.36364" height="4.36364" transform="rotate(-45 438.551 91.8182)" fill="${props.paramFill}"/>
        <rect x="495.091" y="91.6312" width="4.36364" height="4.36364" transform="rotate(-45 495.091 91.6312)" fill="${props.paramFill}"/>
        <circle cx="370" cy="63.4545" r="36" fill="${props.paramFill}"/>
        <rect x="367.818" y="22" width="4.36364" height="4.36364" fill="${props.paramFill}"/>
        <rect x="338.551" y="91.8182" width="4.36364" height="4.36364" transform="rotate(-45 338.551 91.8182)" fill="${props.paramFill}"/>
        <rect x="395.091" y="91.6312" width="4.36364" height="4.36364" transform="rotate(-45 395.091 91.6312)" fill="${props.paramFill}"/>
        <circle cx="270" cy="63.4545" r="36" fill="${props.paramFill}"/>
        <rect x="267.818" y="22" width="4.36364" height="4.36364" fill="${props.paramFill}"/>
        <rect x="238.551" y="91.8182" width="4.36364" height="4.36364" transform="rotate(-45 238.551 91.8182)" fill="${props.paramFill}"/>
        <rect x="295.091" y="91.6312" width="4.36364" height="4.36364" transform="rotate(-45 295.091 91.6312)" fill="${props.paramFill}"/>
        <path class="paramBoxStyle" d="M0 54H175C177.761 54 180 56.2386 180 59V97C180 99.7614 177.761 102 175 102H0V54Z" fill="#C6C2BE"/>
        <g class="boxStyle">
        <rect x="855" y="112" width="308" height="24" rx="4" fill="${props.paramFill}"/>
        <rect x="547" y="20" width="284" height="117" rx="4" fill="black"/>
        <rect x="215" y="112" width="308" height="24" rx="4" fill="${props.paramFill}"/>
        </g>
        <g letter-spacing="${props.fontExtras.space}" font-weight="${props.fontExtras.weight}" fill="${props.fontColour}" font-family="${props.fontName}" >
        <text fill="black" font-size="27"><tspan x="13" y="88.2285">EQ</tspan></text>
        <text font-size="16"><tspan x="249" y="129.969">FREQ</tspan></text>
        <text font-size="16"><tspan x="363" y="129.969">Q</tspan></text>
        <text font-size="16"><tspan x="449" y="129.969">GAIN</tspan></text>
        <text font-size="16"><tspan x="889" y="129.969">FREQ</tspan></text>
        <text font-size="16"><tspan x="1003" y="129.969">Q</tspan></text>
        <text font-size="16"><tspan x="1089" y="129.969">GAIN</tspan></text>
        <path d="M159 78L167.66 68.25H150.34L159 78Z" fill="black"/>
        </g>
    </svg>`

    props.svgReturn(87, svgCode, "bmp00192", 1384, 156);

    return (
        Parse(svgCode)
    );
}

export default BMP20192;